const BROWSER_BACK = `保存されていない入力内容は破棄されます。よろしいですか？`

const WARNS = {
  W001: "{0}は必須入力です。",
  W002: "{0}は{1}文字以上入力してください。",
  W003: "{0}は{1}文字を超えた入力はできません。",
  W004: "{0}は{1}に存在しません。",
  W005: "{0}の入力形式を確認してください。",
  W006: "{0}が許可されていない値が入力されています。",
  W007: "{0}は半角数字のみ入力可能です。",
  W008: "{0}は半角英字のみ入力可能です。",
  W009: "{0}は半角英数字のみ入力可能です。",
  W010: "{0}を選択してください。",
  W4001:
    "既に他で更新されていた一部の明細の更新をスキップしました。受注Noが赤い明細は入力した内容がクリアされ最新データが表示されています。",
} as const

const MESSAGES = {
  BROWSER_BACK,
  WARNS,
} as const

export default MESSAGES
